import * as msgpack from '@mta/msgpack-js-lib';

export default class B2bPublicLogServiceClientProxy {
	/** @constructor */
	constructor(msgpackClient) {
		this._msgpackClient = msgpackClient;
	}

	/**
	 * @param {?string} message
	 * @param {?string} stackTrace
	 * @param {?string} url
	 * @param {?string} browser
	 * @param {?string} clientApplication
	 * @param {?string} clientVersion
	 * @param {Date} clientLaunchDate
	 * @return {Promise<!boolean>}
	 */
	async log(message, stackTrace, url, browser, clientApplication, clientVersion, clientLaunchDate) {
		return this._msgpackClient.call(
				'B2bPublicLogService/Log',
				[
					(os) => os.writeString(message), 
					(os) => os.writeString(stackTrace), 
					(os) => os.writeString(url), 
					(os) => os.writeString(browser), 
					(os) => os.writeString(clientApplication), 
					(os) => os.writeString(clientVersion), 
					(os) => os.writeDate(clientLaunchDate)
				],
				(is, data) => is.readBoolean(data))
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.pub.log.B2bPublicLogServiceClientProxy', B2bPublicLogServiceClientProxy);
